const disclaimerState = {
  isDisplayed: false,
  trackDisplay() {
    if (!this.isDisplayed) {
      if (window._satellite) {
        window._satellite.track('childStayFreeDisclaimerDisplay');
      }
      this.isDisplayed = true;
    }
  },
  reset() {
    this.isDisplayed = false;
  }
};

export function updateChildStayFreeDisclaimer(props) {
  const {
    disclaimerElement,
    childStayFree,
    childMaxAge,
    childAges
  } = props;

  const childAgesArray = Array.isArray(childAges) ? childAges :
    typeof childAges === 'string' ? childAges.split('-').map(Number) :
    [];

  if (childStayFree && childMaxAge !== null) {
    const hasChildrenAboveMaxAge = childAgesArray.some(age => age > childMaxAge);
    
    disclaimerElement.each(function() {
      const $element = $(this);
      const hasLabel = $element.attr('data-i18n-label');
      
      if (hasChildrenAboveMaxAge) {
        const label = hasLabel.replace('{{childMaxAge}}', childMaxAge);
        $element.show();
        $element.find('p.child-stay-free-disclaimer-p').text(label);
        disclaimerState.trackDisplay();
      } else {
        $element.hide();
        disclaimerState.reset();
      }
    });
  } else {
    disclaimerElement.hide();
    disclaimerState.reset();
  }
}
